import { get, post, put } from "../services/HttpService";


export class GstInvoice {
    constructor(invoiceObject = {}) {
        this.set(invoiceObject);
    };

    static validations = {
       
    };

    /**
     * @memberof GstInvoice
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/invoices/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    download = (queryData = {}, config = {}) => {
        return post(`v1/internal/invoices/download/${this.id}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof GstInvoice
     * @type Getter Method
     * @takes void
     * @returns GstInvoice Params
     */
    get = () => {
        return {
            id: this.id,
            month: this.month,
            invoice_number: this.invoice_number,
            gross_amount: this.gross_amount,
            gst_amount: this.gst_amount,
            net_amount: this.net_amount,
        }
    };

    /**
     * @memberof GstInvoice
     * @type Setter Method
     * @takes GstInvoice Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };
}